export default (obj, attr) => delete obj[attr]
